import PropTypes from 'prop-types';

import styles from './EmptyChart.module.scss';

export function EmptyChart({ title }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title ?? 'No results found'}</div>
      <p className={styles.description}>Try adjusting your filters or resetting them to see the data.</p>
    </div>
  );
}

EmptyChart.propTypes = {
  title: PropTypes.string,
};
